// Constants
import {
  SET_MOBILE_MENU_STATE,
  SET_CURRENT_PAGE_TITLE,
  GET_APP_STATISTICS,
} from '~/data/constants/general-constants';

import GeneralService from '~/data/services/challenges-services';

/**
 * Changes the Mobile Menu state
 * (if closed or opened)
 *
 * @export
 * @param {any} title
 * @returns
 */
export function setMobileMenuState(state) {
  return {
    type: SET_MOBILE_MENU_STATE,
    menu: state,
  };
}

/**
 * Changes the Page Title in the header
 * (mobile only)
 *
 * @export
 * @param {any} title
 * @returns
 */
export function setCurrentPageTitle(title) {
  return {
    type: SET_CURRENT_PAGE_TITLE,
    title: title,
  };
}

export function getAppStatistics() {
  return dispatch => {
    GeneralService.findGlobalStats()
      .then(response => {
        if (response.data) {
          dispatch(updateStore(response.data));
        } else {
          console.error('Response: ', response.status);
        }
      })
      .catch(error => {
        console.error('Response: ', error.status);
      });
  };

  function updateStore(statistics) {
    return {
      type: GET_APP_STATISTICS,
      statistics: statistics,
    };
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/general-actions.jsx